import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0006',
    ecrans: ['00-2']
});
